// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card__post[data-v-61da0661]{max-width:910px;margin:auto}", ""]);
// Exports
module.exports = exports;
